var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Reglages") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Anneaux concentriques et curseurs de reglage.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 173.1 L 444.6 285.3 L 261.7 390.9 L 67.4 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 244.6,
    y1: 202.8,
    x2: 118.8,
    y2: 275.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 281.7,
    y1: 224.2,
    x2: 156,
    y2: 296.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 318.9,
    y1: 245.7,
    x2: 193.1,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 356,
    y1: 267.1,
    x2: 230.3,
    y2: 339.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 393.2,
    y1: 288.6,
    x2: 267.4,
    y2: 361.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 244.6,
    y1: 202.8,
    x2: 393.2,
    y2: 288.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 202.7,
    y1: 227,
    x2: 351.3,
    y2: 312.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 160.7,
    y1: 251.2,
    x2: 309.3,
    y2: 337
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 118.8,
    y1: 275.4,
    x2: 267.4,
    y2: 361.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 322.6 280.8 L 308.9 288.8 L 308.9 300 L 322.6 292.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 295.2 280.8 L 308.9 288.8 L 308.9 300 L 295.2 292.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 308.9 272.9 L 322.6 280.8 L 308.9 288.8 L 295.2 280.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 308.9 272.9 L 322.6 280.8 L 308.9 288.8 L 295.2 280.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 322.6,
    y1: 280.8,
    x2: 322.6,
    y2: 292.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 308.9,
    y1: 288.8,
    x2: 308.9,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 295.2,
    y1: 280.8,
    x2: 295.2,
    y2: 292.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 322.6,
    y1: 292.1,
    x2: 308.9,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 308.9,
    y1: 300,
    x2: 295.2,
    y2: 292.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 289.1 292 L 275.4 299.9 L 275.4 311.2 L 289.1 303.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 261.6 292 L 275.4 299.9 L 275.4 311.2 L 261.6 303.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 275.4 284.1 L 289.1 292 L 275.4 299.9 L 261.6 292 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 275.4 284.1 L 289.1 292 L 275.4 299.9 L 261.6 292 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 289.1,
    y1: 292,
    x2: 289.1,
    y2: 303.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 275.4,
    y1: 299.9,
    x2: 275.4,
    y2: 311.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.6,
    y1: 292,
    x2: 261.6,
    y2: 303.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 289.1,
    y1: 303.2,
    x2: 275.4,
    y2: 311.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 275.4,
    y1: 311.2,
    x2: 261.6,
    y2: 303.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 250.4 292 L 236.6 299.9 L 236.6 311.2 L 250.4 303.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 222.9 292 L 236.6 299.9 L 236.6 311.2 L 222.9 303.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 236.6 284.1 L 250.4 292 L 236.6 299.9 L 222.9 292 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 236.6 284.1 L 250.4 292 L 236.6 299.9 L 222.9 292 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 250.4,
    y1: 292,
    x2: 250.4,
    y2: 303.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 236.6,
    y1: 299.9,
    x2: 236.6,
    y2: 311.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 222.9,
    y1: 292,
    x2: 222.9,
    y2: 303.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 250.4,
    y1: 303.2,
    x2: 236.6,
    y2: 311.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 236.6,
    y1: 311.2,
    x2: 222.9,
    y2: 303.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 216.8 280.8 L 203.1 288.8 L 203.1 300 L 216.8 292.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 189.4 280.8 L 203.1 288.8 L 203.1 300 L 189.4 292.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 203.1 272.9 L 216.8 280.8 L 203.1 288.8 L 189.4 280.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 203.1 272.9 L 216.8 280.8 L 203.1 288.8 L 189.4 280.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 216.8,
    y1: 280.8,
    x2: 216.8,
    y2: 292.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 203.1,
    y1: 288.8,
    x2: 203.1,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 189.4,
    y1: 280.8,
    x2: 189.4,
    y2: 292.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 216.8,
    y1: 292.1,
    x2: 203.1,
    y2: 300
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 203.1,
    y1: 300,
    x2: 189.4,
    y2: 292.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 197.5 261.5 L 183.8 269.4 L 183.8 280.6 L 197.5 272.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 170.1 261.5 L 183.8 269.4 L 183.8 280.6 L 170.1 272.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 183.8 253.6 L 197.5 261.5 L 183.8 269.4 L 170.1 261.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 183.8 253.6 L 197.5 261.5 L 183.8 269.4 L 170.1 261.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 197.5,
    y1: 261.5,
    x2: 197.5,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 183.8,
    y1: 269.4,
    x2: 183.8,
    y2: 280.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 170.1,
    y1: 261.5,
    x2: 170.1,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 197.5,
    y1: 272.7,
    x2: 183.8,
    y2: 280.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 183.8,
    y1: 280.6,
    x2: 170.1,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 197.5 239.1 L 183.8 247.1 L 183.8 258.3 L 197.5 250.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 170.1 239.1 L 183.8 247.1 L 183.8 258.3 L 170.1 250.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 183.8 231.2 L 197.5 239.1 L 183.8 247.1 L 170.1 239.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 183.8 231.2 L 197.5 239.1 L 183.8 247.1 L 170.1 239.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 197.5,
    y1: 239.1,
    x2: 197.5,
    y2: 250.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 183.8,
    y1: 247.1,
    x2: 183.8,
    y2: 258.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 170.1,
    y1: 239.1,
    x2: 170.1,
    y2: 250.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 197.5,
    y1: 250.4,
    x2: 183.8,
    y2: 258.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 183.8,
    y1: 258.3,
    x2: 170.1,
    y2: 250.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 216.8 219.8 L 203.1 227.7 L 203.1 238.9 L 216.8 231 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 189.4 219.8 L 203.1 227.7 L 203.1 238.9 L 189.4 231 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 203.1 211.9 L 216.8 219.8 L 203.1 227.7 L 189.4 219.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 203.1 211.9 L 216.8 219.8 L 203.1 227.7 L 189.4 219.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 216.8,
    y1: 219.8,
    x2: 216.8,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 203.1,
    y1: 227.7,
    x2: 203.1,
    y2: 238.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 189.4,
    y1: 219.8,
    x2: 189.4,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 216.8,
    y1: 231,
    x2: 203.1,
    y2: 238.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 203.1,
    y1: 238.9,
    x2: 189.4,
    y2: 231
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 250.4 208.6 L 236.6 216.5 L 236.6 227.8 L 250.4 219.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 222.9 208.6 L 236.6 216.5 L 236.6 227.8 L 222.9 219.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 236.6 200.7 L 250.4 208.6 L 236.6 216.5 L 222.9 208.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 236.6 200.7 L 250.4 208.6 L 236.6 216.5 L 222.9 208.6 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 250.4,
    y1: 208.6,
    x2: 250.4,
    y2: 219.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 236.6,
    y1: 216.5,
    x2: 236.6,
    y2: 227.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 222.9,
    y1: 208.6,
    x2: 222.9,
    y2: 219.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 250.4,
    y1: 219.8,
    x2: 236.6,
    y2: 227.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 236.6,
    y1: 227.8,
    x2: 222.9,
    y2: 219.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 289.1 208.6 L 275.4 216.5 L 275.4 227.8 L 289.1 219.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 261.6 208.6 L 275.4 216.5 L 275.4 227.8 L 261.6 219.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 275.4 200.7 L 289.1 208.6 L 275.4 216.5 L 261.6 208.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 275.4 200.7 L 289.1 208.6 L 275.4 216.5 L 261.6 208.6 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 289.1,
    y1: 208.6,
    x2: 289.1,
    y2: 219.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 275.4,
    y1: 216.5,
    x2: 275.4,
    y2: 227.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 261.6,
    y1: 208.6,
    x2: 261.6,
    y2: 219.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 289.1,
    y1: 219.8,
    x2: 275.4,
    y2: 227.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 275.4,
    y1: 227.8,
    x2: 261.6,
    y2: 219.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 322.6 219.8 L 308.9 227.7 L 308.9 238.9 L 322.6 231 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 295.2 219.8 L 308.9 227.7 L 308.9 238.9 L 295.2 231 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 308.9 211.9 L 322.6 219.8 L 308.9 227.7 L 295.2 219.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 308.9 211.9 L 322.6 219.8 L 308.9 227.7 L 295.2 219.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 322.6,
    y1: 219.8,
    x2: 322.6,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 308.9,
    y1: 227.7,
    x2: 308.9,
    y2: 238.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 295.2,
    y1: 219.8,
    x2: 295.2,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 322.6,
    y1: 231,
    x2: 308.9,
    y2: 238.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 308.9,
    y1: 238.9,
    x2: 295.2,
    y2: 231
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 341.9 239.1 L 328.2 247.1 L 328.2 258.3 L 341.9 250.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 314.5 239.1 L 328.2 247.1 L 328.2 258.3 L 314.5 250.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 328.2 231.2 L 341.9 239.1 L 328.2 247.1 L 314.5 239.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 328.2 231.2 L 341.9 239.1 L 328.2 247.1 L 314.5 239.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 341.9,
    y1: 239.1,
    x2: 341.9,
    y2: 250.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 328.2,
    y1: 247.1,
    x2: 328.2,
    y2: 258.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 314.5,
    y1: 239.1,
    x2: 314.5,
    y2: 250.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 341.9,
    y1: 250.4,
    x2: 328.2,
    y2: 258.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 328.2,
    y1: 258.3,
    x2: 314.5,
    y2: 250.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 341.9 261.5 L 328.2 269.4 L 328.2 280.6 L 341.9 272.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 314.5 261.5 L 328.2 269.4 L 328.2 280.6 L 314.5 272.7 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 328.2 253.6 L 341.9 261.5 L 328.2 269.4 L 314.5 261.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 328.2 253.6 L 341.9 261.5 L 328.2 269.4 L 314.5 261.5 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 341.9,
    y1: 261.5,
    x2: 341.9,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 328.2,
    y1: 269.4,
    x2: 328.2,
    y2: 280.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 314.5,
    y1: 261.5,
    x2: 314.5,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 341.9,
    y1: 272.7,
    x2: 328.2,
    y2: 280.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 328.2,
    y1: 280.6,
    x2: 314.5,
    y2: 272.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 201.7 247.3 L 201.7 263.9 A 54.3 31.3 0 0 0 310.3 263.9 L 310.3 247.3 A 54.3 31.3 0 0 1 201.7 247.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 201.7 247.3 L 201.7 263.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 310.3 247.3 L 310.3 263.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    fill: "none",
    d: "M 201.7 263.9 A 54.3 31.3 0 0 0 310.3 263.9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 256,
    cy: 247.3,
    rx: 54.3,
    ry: 31.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    fill: "none",
    cx: 256,
    cy: 247.3,
    rx: 54.3,
    ry: 31.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 238.3 240.8 L 238.3 247.3 A 17.7 10.2 0 0 0 273.7 247.3 L 273.7 240.8 A 17.7 10.2 0 0 1 238.3 240.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "M 238.3 240.8 L 238.3 247.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "M 273.7 240.8 L 273.7 247.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2",
    fill: "none",
    d: "M 238.3 247.3 A 17.7 10.2 0 0 0 273.7 247.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "face",
    cx: 256,
    cy: 240.8,
    rx: 17.7,
    ry: 10.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a2",
    fill: "none",
    cx: 256,
    cy: 240.8,
    rx: 17.7,
    ry: 10.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d1",
    cx: 256,
    cy: 239.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 256,
    cy: 239.8,
    r: 4.2
  })), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 264.6,
    y1: 194.5,
    x2: 390.3,
    y2: 267.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 264.6,
    y1: 194.5,
    x2: 308.6,
    y2: 220
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 308.6,
    cy: 220,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 308.6,
    cy: 220,
    r: 3.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 278.9,
    y1: 186.3,
    x2: 404.6,
    y2: 258.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 278.9,
    y1: 186.3,
    x2: 369.4,
    y2: 238.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d6",
    cx: 369.4,
    cy: 238.6,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 369.4,
    cy: 238.6,
    r: 3.6
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.afbfe1fe15d2ea92628ee7f2cf2da4aa.svg";
export { ForwardRef as ReactComponent };